import { render, staticRenderFns } from "./BillSendDetail.vue?vue&type=template&id=76df3540&scoped=true"
import script from "./BillSendDetail.vue?vue&type=script&lang=js"
export * from "./BillSendDetail.vue?vue&type=script&lang=js"
import style0 from "./BillSendDetail.vue?vue&type=style&index=0&id=76df3540&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df3540",
  null
  
)

export default component.exports